import React, {useContext} from "react";
import { PERMISSIONS, useUser } from "./UserContext";

const defaultValue = {
    title: '',
    component: (<div></div>),
    open: false,
    openId: 0,
    modal2: {
        open: false,
        component: null,
        title: ''
    }
}

export const ModalActions = {
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    SET_MODAL_TITLE: 'SET_MODAL_TITLE',
}

const ModalContext = React.createContext(defaultValue)

function modalReducer(state, action)
{
    switch (action.type)
    {
        case ModalActions.OPEN_MODAL: {
            // Her açılışta artan kimlik: Modal.js'te key olarak kullanılıp içeriğin
            // taze mount olmasını (bayat component sorunu) sağlar; setTimeout hack'i kaldırıldı.
            const openId = (state.openId ?? 0) + 1;

            if(state.open)
            {
                return {
                    ...state,
                    openId,
                    modal2: {
                        open: true,
                        component: action.component,
                        title: action.title,
                        onCloseFn: action.onCloseFn,
                    }
                }
            }

            return {
                ...state,
                openId,
                open: true,
                component: action.component,
                title: action.title,
                onCloseFn: action.onCloseFn,
                width: action.width,
                top: action.top,
            }
        }
        case ModalActions.SET_MODAL_TITLE: {
            return {
                ...state,
                title: action.title,
            }
        }
        case ModalActions.CLOSE_MODAL: {
            // typeof kontrolü ŞART: openModal konumsal argüman alıyor (title, component, onCloseFn, …).
            // Çağıran 3. sıraya yanlışlıkla bir seçenek nesnesi geçerse truthy olur ve çağrıldığında
            // "onCloseFn is not a function" ile TÜM uygulamayı düşürürdü. Kapanış yolu bunu yutmamalı.
            if(state.modal2.open)
            {
                if (typeof state.modal2.onCloseFn === 'function')
                    state.modal2.onCloseFn()

                return {
                    ...state,
                    modal2: defaultValue.modal2
                }
            }

            if (typeof state.onCloseFn === 'function')
                state.onCloseFn()

            return defaultValue
        }
        default: {
            return defaultValue
        }
    }
}

function ModalProvider({children})
{
    const [modal, dispatch] = React.useReducer(modalReducer, defaultValue);

    const value = {modal, dispatch};

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    )
}

function useModal()
{
    const context = React.useContext(ModalContext);

    if(!context)
        throw new Error('Modal Provider Error')

    const {modal, dispatch} = context;

    const openModal = (title, component, onCloseFn, width, top) => {
        dispatch({
            type: ModalActions.OPEN_MODAL,
            component: component,
            title: title,
            width,
            top,
            onCloseFn
        })
    }

    const closeModal = () => {
        dispatch({
            type: ModalActions.CLOSE_MODAL,
        })
    }

    // Açık modalın başlığını (string veya component) sonradan güncelle.
    const setModalTitle = (title) => {
        dispatch({
            type: ModalActions.SET_MODAL_TITLE,
            title,
        })
    }

    return {
        modal: modal,
        openModal,
        closeModal,
        setModalTitle
    }
}

export {ModalProvider, useModal}
